module.exports = __webpack_public_path__ + "img/falso-verdadero.5323e0ef.svg";